import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import { PercentageInput } from '../../UI/components/Form';
import { NoteReceivableFormValues } from '../types';

interface NoteReceivableOwnershipAllocationInputProps {
  className?: string;
}

export const NoteReceivableOwnershipAllocationInput: FC<NoteReceivableOwnershipAllocationInputProps> = ({
  className,
}) => {
  const { t: tForm } = useTranslation('form');
  const { control } = useFormContext<NoteReceivableFormValues>();
  const {
    field,
    formState: { errors },
  } = useController<NoteReceivableFormValues, 'ownershipAllocation'>({
    control,
    name: 'ownershipAllocation',
    rules: { required: true },
  });

  return (
    <PercentageInput
      {...field}
      decimalsLimit={3}
      className={className}
      allowNegativeValue={false}
      placeholder={tForm('general-required-placeholder')}
      label={tForm('general-ownership-allocation-input')}
      status={errors.ownershipAllocation ? 'errored' : 'normal'}
    />
  );
};
